import { observable, configure, action, computed, runInAction } from 'mobx';
import LocalModel from './localModel';

import util from 'preact-util';
import { route } from 'preact-router';
import PubSub, { topics } from '../lib/pubsub';

configure({ enforceActions: 'always' });

class StreamStore extends LocalModel {
    constructor() {
        super('stream', {
            namePlural: 'streams',
            namePluralReal: 'streams',
            sort: 'start',
            limit: 500,
            api: {
                search: {
                    url: '/api/streams/',
                    params: {
                        limit: 15,
                        sort: 'timestamp',
                    },
                },
                load: {
                    url: '/api/streams/',
                    params: {},
                },
                save: {
                    url: '/api/streams/',
                    params: {},
                },
                delete: {
                    url: '/api/streams/',
                    params: {},
                },
            },
        });
    }

    @observable newStream = {};

    @observable stream = {};

    @observable streams = [];

    @observable producerStreams = [];

    @observable showOfflineStreams = false;

    @observable showInactiveStreams = false;

    @observable showPastStreams = false;

    @action
    async loadStreamsForDateRange(startDate, endDate, { race } = {}) {
        const query = {
            limit: 500,
            sort: 'start',
            includeOffline: '0',
            includeInactive: '1',
            startFrom: startDate.toISOString(),
            endTo: endDate.toISOString(),
        };
        if (race) {
            query.race = race;
        }
        const response = await util.fetchApi('/api/streams/', { method: 'GET' }, query);
        if (response?.status === 200) {
            runInAction(() => {
                this.producerStreams = response.data || [];
            });
        }
        return this.producerStreams;
    }
}

const store = new StreamStore();
export default store;
